import { isEqual } from 'lodash';
import { debugLogger } from '../debug/DebugLogger';

const log = debugLogger.scope('filters');

type PeersetFilterFirst = {
  mandatory?: string[];
  active?: string[];
};

type PeersetFilterTransitionInput = {
  prevPeersetFilterId: string | null;
  prevPeersetFilterFirst: PeersetFilterFirst | null;
  filterId?: string;
  filterFirst?: PeersetFilterFirst | null;
};

type PeersetFilterTransition = {
  sameFilterAsPreviousPeerset: boolean;
  reuseFiltersForSamePeerset: boolean;
  openFilterFirstOnPeersetChange: boolean;
  resetActiveFilters: boolean;
};

export const getPeersetFilterTransition = ({
  prevPeersetFilterId,
  prevPeersetFilterFirst,
  filterId,
  filterFirst,
}: PeersetFilterTransitionInput): PeersetFilterTransition => {
  const sameFilterAsPreviousPeerset =
    !!prevPeersetFilterId && filterId === prevPeersetFilterId;
  const sameFilterFirstAsPreviousPeerset =
    sameFilterAsPreviousPeerset && isEqual(prevPeersetFilterFirst, filterFirst);
  // Same-filterId peerset with identical filterFirst: reuse entered filters, skip the modal
  const reuseFiltersForSamePeerset =
    !!filterFirst?.mandatory && sameFilterFirstAsPreviousPeerset;
  // filterFirst modal reopens on this peerset change: clear entered filters so it shows defaults
  const openFilterFirstOnPeersetChange =
    !!filterFirst?.mandatory && !reuseFiltersForSamePeerset;
  const resetActiveFilters =
    !sameFilterAsPreviousPeerset || openFilterFirstOnPeersetChange;

  /** @debugFeature filters Logs the peerset filter transition decision: inputs and all four resulting flags (reuse filters, reopen filterFirst, reset). */
  log('peerset filter transition resolved', () => ({
    prevPeersetFilterId,
    filterId,
    sameFilterAsPreviousPeerset,
    reuseFiltersForSamePeerset,
    openFilterFirstOnPeersetChange,
    resetActiveFilters,
  }));

  return {
    sameFilterAsPreviousPeerset,
    reuseFiltersForSamePeerset,
    openFilterFirstOnPeersetChange,
    resetActiveFilters,
  };
};
